import { Button, Row } from "antd";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableConstats from "../../components/tables/TableConstats/TableConstats";
import { useLazyFetchPaginatedConstatsQuery } from "../../features/api/apiSlice";
import { useCrudConstat } from "../../features/api/crud/hooks/useCrudConstat";

const PagePdcaConstat: React.FC = () => {
  const [fetchConstats, { data, isFetching }] =
    useLazyFetchPaginatedConstatsQuery();

  const { onDelete } = useCrudConstat({ fetchConstats: () => fetchConstats() });

  return (
    <PageLayout>
      <Row justify="space-between" align="middle">
        <h1>PDCA - Constat</h1>
        <Link to="/constats/new">
          <Button type="primary">CrÃ©er un constat</Button>
        </Link>
      </Row>
      <Row>
        <TableConstats
          data={data}
          fetchData={fetchConstats}
          isLoading={isFetching}
          onDelete={onDelete}
        />
      </Row>
    </PageLayout>
  );
};

export default PagePdcaConstat;
